import Button from '@shared/components/Button/Button';
import ListItem from '@shared/components/ListItem/ListItem';
import { useTranslation } from 'react-i18next';

import { ReactComponent as ArrowDown } from 'assets/icons/ArrowDown.svg';

import DefaultRoleBadge from './DefaultRoleBadge';
import InheritedRoleBadge from './InheritedRoleBadge';

interface RoleListItemProps {
  name: string;
  onClick: () => void;
  permissionsCount: number;
  isDefaultRole: boolean;
  isInheritedRole?: boolean;
}

const RoleListItem = ({
  name,
  onClick,
  permissionsCount,
  isDefaultRole,
  isInheritedRole = false,
}: RoleListItemProps) => {
  const { t } = useTranslation();

  const permissionsCountText = t('permission', { count: permissionsCount });

  // AC-042 / AC-151 — badges are mutually exclusive. The data invariant in
  // tech.md §3.8 prevents a role from being both default and inherited, but
  // we still resolve a single badge here so a future bug can't render both.
  const badge = isInheritedRole ? <InheritedRoleBadge /> : isDefaultRole ? <DefaultRoleBadge /> : null;

  return (
    <ListItem className="h-full gap-1 md:p-4 p-2 group" onClick={onClick}>
      <div className="flex md:flex-row flex-col gap-0 md:gap-2">
        <p className="font-medium text-black">{name}</p>
        <p className="text-size-xs text-gray-80 block md:hidden">{permissionsCountText}</p>
        {badge}
      </div>
      <ListItem.RightSide className="h-full w-auto gap-2">
        <p className="text-size-xs text-gray-80 hidden md:block">{permissionsCountText}</p>
        <Button variant="textSecondary" className="group-hover:text-primary-50">
          <ArrowDown className="stroke-1.5 stroke-current transition-transform -rotate-90" />
        </Button>
      </ListItem.RightSide>
    </ListItem>
  );
};

export default RoleListItem;
